import { useSelector, shallowEqual } from 'react-redux'


export type Allowance = string

export function useReportAllowances() {
  const allowances = useSelector((state: any) => state.reports.subsidies.data.allowances, shallowEqual)
  if (allowances && Array.isArray(allowances)) return allowances as Array<Allowance>
  return null
}
